import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../styles/media'
import '../../../fonts/nutmeg/index.css'
import { fonts, colors } from '../../styles/theme'

const S = {}

const timeStyles = (size) => {
  const fonts = {
    l: css`
      font-size: 8.5rem;
      letter-spacing: 0.53125rem;
    `,
    m: css`
      font-size: 4.5rem;
      letter-spacing: 0.25rem;
    `,
    s: css`
      font-size: 4rem;
      letter-spacing: 0.25rem;
    `,
    xs: css`
      font-size: 2.75rem;
      letter-spacing: 0.125rem;
    `,
  }
  return fonts[size]
}

const labelStyles = (size) => {
  const fonts = {
    l: css`
      font-size: 1.75rem;
      line-height: 1.29;
      letter-spacing: -0.5px;
      margin-top: 0.5rem;
    `,
    m: css`
      font-size: 1.125rem;
      line-height: 1.56;
      letter-spacing: 1px;
    `,
    s: css`
      font-size: 0.875rem;
      letter-spacing: 0.78px;
    `,
    xs: css`
      font-size: 0.75rem;
      letter-spacing: 0.375px;
    `,
  }
  return fonts[size]
}

const dividerStyles = (size) => {
  const fonts = {
    l: css`
      font-size: 8.5rem;
      letter-spacing: 0.53125rem;
      margin-inline: 0rem;
    `,
    m: css`
      font-size: 4.5rem;
      letter-spacing: 0.25rem;
      margin-inline: 0rem;
    `,
    s: css`
      font-size: 4rem;
      margin-inline-start: 0.125rem;
      margin-inline-end: 0.25rem;
    `,
    xs: css`
      font-size: 2.5rem;
      letter-spacing: 0.125rem;
      margin-inline: 0.25rem;
    `,
  }
  return fonts[size]
}

S.Countdown = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  text-align: center;
  color: ${({ useCustomStyles }) =>
    useCustomStyles ? 'inherit' : colors.white};
  font-family: ${({ useCustomFont }) =>
    useCustomFont ? 'inherit' : fonts.nutmeg};

  .countdown-item-time {
    font-weight: ${({ useCustomFont }) => (useCustomFont ? 'inherit' : '900')};
    margin: 0 0 0.25rem 0;
    ${({ size, isFixedSize }) =>
      size === 'l' &&
      !isFixedSize &&
      css`
        ${timeStyles('s')};

        ${media.sm`
          ${timeStyles('m')};
        `};

        ${media.lg`
          ${timeStyles('l')};
        `};
      `};

    ${({ size, isFixedSize }) =>
      size === 'l' &&
      isFixedSize &&
      css`
        ${timeStyles('l')};
      `};

    ${({ size, isFixedSize }) =>
      size === 'm' &&
      !isFixedSize &&
      css`
        ${timeStyles('s')};

        ${media.sm`
          ${timeStyles('m')};
        `};
      `};

    ${({ size, isFixedSize }) =>
      size === 'm' &&
      isFixedSize &&
      css`
        ${timeStyles('m')};
      `};

    ${({ size, isFixedSize }) =>
      size === 's' &&
      !isFixedSize &&
      css`
        ${timeStyles('xs')};

        ${media.sm`
          ${timeStyles('s')};
        `};
      `};

    ${({ size, isFixedSize }) =>
      size === 's' &&
      isFixedSize &&
      css`
        ${timeStyles('s')};
      `};

    ${({ size, isFixedSize }) =>
      size === 'xs' &&
      isFixedSize &&
      css`
        ${timeStyles('xs')};
      `};
  }

  .countdown-item-label {
    text-transform: uppercase;
    font-family: ${({ useCustomFont }) =>
      useCustomFont ? 'inherit' : fonts.nutmeg};

    ${({ size, isFixedSize }) =>
      size === 'l' &&
      !isFixedSize &&
      css`
        ${labelStyles('s')};

        ${media.sm`
          ${labelStyles('m')};
        `};

        ${media.lg`
          ${labelStyles('l')};
        `};
      `};

    ${({ size, isFixedSize }) =>
      size === 'l' &&
      isFixedSize &&
      css`
        ${labelStyles('l')};
      `};

    ${({ size, isFixedSize }) =>
      size === 'm' &&
      !isFixedSize &&
      css`
        ${labelStyles('s')};

        ${media.sm`
          ${labelStyles('m')};
        `};
      `};

    ${({ size, isFixedSize }) =>
      size === 'm' &&
      isFixedSize &&
      css`
        ${labelStyles('m')};
      `};

    ${({ size, isFixedSize }) =>
      size === 's' &&
      !isFixedSize &&
      css`
        ${labelStyles('xs')};

        ${media.sm`
          ${labelStyles('s')};
        `};
      `};

    ${({ size, isFixedSize }) =>
      size === 's' &&
      isFixedSize &&
      css`
        ${labelStyles('s')};
      `};

    ${({ size, isFixedSize }) =>
      size === 'xs' &&
      isFixedSize &&
      css`
        ${labelStyles('xs')};
      `};
  }

  .countdown-item {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-decoration: none;

    &-days {
      display: ${({ zeroDaysLeft }) => (zeroDaysLeft ? 'none' : 'flex')};
    }
    &-seconds {
      display: ${({ zeroDaysLeft }) => (zeroDaysLeft ? 'flex' : 'none')};
    }
  }

  .divider {
    font-weight: ${({ useCustomFont }) => (useCustomFont ? 'inherit' : '900')};
    margin: 0 0 0.25rem 0;
    ${({ size, isFixedSize }) =>
      size === 'l' &&
      !isFixedSize &&
      css`
        ${dividerStyles('s')};

        ${media.sm`
          ${dividerStyles('m')};
        `};

        ${media.lg`
          ${dividerStyles('l')};
        `};
      `};

    ${({ size, isFixedSize }) =>
      size === 'l' &&
      isFixedSize &&
      css`
        ${dividerStyles('l')};
      `};

    ${({ size, isFixedSize }) =>
      size === 'm' &&
      !isFixedSize &&
      css`
        ${dividerStyles('s')};

        ${media.sm`
          ${dividerStyles('m')};
        `};
      `};

    ${({ size, isFixedSize }) =>
      size === 'm' &&
      isFixedSize &&
      css`
        ${dividerStyles('m')};
      `};

    ${({ size, isFixedSize }) =>
      size === 's' &&
      !isFixedSize &&
      css`
        ${dividerStyles('xs')};

        ${media.sm`
          ${dividerStyles('s')};
        `};
      `};

    ${({ size, isFixedSize }) =>
      size === 's' &&
      isFixedSize &&
      css`
        ${dividerStyles('s')};
      `};

    ${({ size, isFixedSize }) =>
      size === 'xs' &&
      isFixedSize &&
      css`
        ${dividerStyles('xs')};
      `};

    &-days {
      display: ${({ zeroDaysLeft }) => (zeroDaysLeft ? 'none' : 'flex')};
    }

    &-minutes {
      display: ${({ zeroDaysLeft }) => (zeroDaysLeft ? 'flex' : 'none')};
    }
  }
`

export default S
